import { createDedicatedInvestorPortalEnvironment, EnvNames } from '@pinnakl/core/environment';

export const environment = createDedicatedInvestorPortalEnvironment(EnvNames.dev);
